
import ConfigListTreeParser from '../helpers/ConfigListTreeParser'
import type {ConfigversionsInfo} from '@/types'
import Vue from "vue";
import { mapGetters, mapActions } from 'vuex'
const _ = require("lodash")

export default Vue.extend({
  name: "SelectConfigDialog",
  props : {
    dialogVisible : {
      type: Boolean,
      default: () => false 
    },
    outLoc : {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {      
      selected : [] as Array<any>,
      search: null as any, 
      headers : [
        {
          text: 'Version',
          align: 'start',
          sortable: false,
          value: 'version',
        },
        { text: 'Created', value: 'created' },
        { text: 'Creator', value: 'creator' },
        { text: 'Release Tag', value: 'release' },
      ],
      selectedDB : [] as any,
      dbItems : [] as Array<string>,
      caseSensitive : false as boolean,
      loadingConfigs : false as boolean, 
      active : [] as any,
      dialogHeader : "Select Configuration",
      tableItems : [],
      
      configsListNodeMap : {},
      idCounter : 0 as number,     
    }
        
  },
  methods: {
    ...mapActions({
      fetchDBNames: 'fetchDBNames',
      fetchCfgFromServerByName: 'fetchCfgFromServerByName',
      setSnackBarText: 'setSnackBarText',
      fetchConfigurationList: 'fetchConfigurationList',
      setStartLoadingConfig: 'setStartLoadingConfig',
      setConfigLoaded: 'setConfigLoaded',
      clearStoreState: 'clearStoreState',
      setConfigsListLoaded: 'setConfigsListLoaded',
      setInitialConfigsIDCounter: 'setInitialConfigsIDCounter',
      createConfigsListNodesMap: 'createConfigsListNodesMap',
    }),

    selectConfig() : void {      
      this.$emit('update:'+this.outLoc,this.selectedDB+":"+this.selected[0].path)
      this.$emit('update:dialogVisible', false)
    },
    closeDialog() : void {    
      this.selected = []      
      this.$emit('update:'+this.outLoc,"")
      this.$emit('update:dialogVisible', false)
    },
    updateActiveNodes(array: any): void {
      //console.log('AAA')
      let difference: number = parseInt(
        this.active
          .filter((x) => !array.includes(x))
          .concat(array.filter((x) => !this.active.includes(x)))
      )
      if (array.length != 0) difference = array[0]
      if (Object.keys(this.getConfigsListNodesMap).length !== 0) {
        console.log(
          JSON.stringify(this.getConfigsListNodesMap[difference].versionsInfo)
        )
        this.tableItems = _.cloneDeep(this.getConfigsListNodesMap[difference].versionsInfo)
        this.tableItems.sort((a: ConfigversionsInfo ,b : ConfigversionsInfo) => {
          //first entry is always V
          return parseInt(b.version.substring(1)) - parseInt(a.version.substring(1))

        }
      )
      }
      this.active = array
    }, 
    async createConfigurationsList(): Promise<void> {
      //reset maps and ID counters
      this.configsListNodeMap = {}
      this.idCounter = 1
      this.loadingConfigs = true
      
      this.setConfigsListLoaded(false)
      Promise.all([await this.$store.dispatch('fetchConfigurationList',this.selectedDB)])
        .finally(async () => {
          let ret = ConfigListTreeParser.parseConfigs(
            this.cfgList,
            this.configsListNodeMap,
            this.idCounter
          )
          this.idCounter = ret['idCounter']

      
          this.createConfigsListNodesMap(this.configsListNodeMap)
          //initilaize id counter in the store so other components can get/modify it
          this.setInitialConfigsIDCounter(this.idCounter)
          this.setConfigsListLoaded(true)

          this.loadingConfigs = false

        })
        .catch((error) => {
          this.setSnackBarText({
            snackBarText: error,
            snackBarColor: 'red',
          })
        })
    }

  },
  computed: {
    ...mapGetters({
      cfgList: 'getConfigurationsList',
      getConfigsListNodesMap: 'getConfigsListNodesMap',
      getDarkMode: 'getDarkMode',
      dbNames: 'getDBNames',
    }),
    filter() : any {
      return this.caseSensitive
        ? (item, search, textKey) => {
          item[textKey].indexOf(search) > -1
        }
      : undefined
    },
    cfgItems(): any {
      return [this.getConfigsListNodesMap[1]]      
    }
  },  
  watch: {
    dialogVisible : async function (newVal){
      console.log("vis",newVal)
      if(newVal){  
        await this.$store.dispatch("fetchDBNames")
        console.log("featch",this.$store.state.dbNames)
      }
    },
    selectedDB : async function() {
      await this.createConfigurationsList()    
    }
  },
});
